import React, { Component } from "react";
import axios from "axios";
import {
  TextField,
  Typography,
  Box,
  Card,
  CardContent,
  CardActionArea,
  TablePagination,
  IconButton,
} from "@mui/material";
import Serverurl from "./Apiurl";
import Fab from "@mui/material/Fab";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";

class Invoiceothercharges extends Component {
  constructor(props) {
    super(props);

    this.state = {
      othercharges: [],
      page: 0,
      rowsPerPage: 5,
      totalItems: 0,
      searchName: "",
    };
  }

  componentDidMount() {
    this.fetchOthercharges();
  }

  handleSearchChange = (e) => {
    this.setState({
      searchName: e.target.value,
      page: 0,
    });
  };

  fetchOthercharges = () => {
    const bu_id = localStorage.getItem("GBuserid");

    axios
      .get(
        Serverurl +
          "ajaxothercharges.php?action=getall" +
          "&StartIndex=" +
          this.state.page +
          "&PageSize=" +
          this.state.rowsPerPage +
          "&otc_title=" +
          encodeURIComponent(this.state.searchName) +
          "&otc_bu_id=" +
          bu_id
      )
      .then((res) => {
        this.setState({
          othercharges: Array.isArray(res.data)
            ? res.data
            : [],
          totalItems: parseInt(
            res.data?.[0]?.total || 0,
            10
          ),
        });
      })
      .catch((error) => {
        console.error(
          "FETCH OTHER CHARGES ERROR:",
          error
        );

        this.setState({
          othercharges: [],
          totalItems: 0,
        });
      });
  };

  onPageChange = (event, newPage) => {
    this.setState(
      {
        page: newPage,
      },
      this.fetchOthercharges
    );
  };

  onRowsPerPageChange = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(
          event.target.value,
          10
        ),
        page: 0,
      },
      this.fetchOthercharges
    );
  };

  render() {
    return (
      <Box sx={{ p: 2 }}>
        {/* SEARCH */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            mb: 3,
          }}
        >
          <Box sx={{ display: "flex" }}>
            <TextField
              variant="outlined"
              value={this.state.searchName}
              onChange={this.handleSearchChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this.fetchOthercharges();
                }
              }}
              size="small"
              fullWidth
              placeholder="Type here..."
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={
                        this.fetchOthercharges
                      }
                      edge="end"
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>

        {/* OTHER CHARGES LIST */}
        {this.state.othercharges.map((o) => (
          <Card
            key={o.otc_id}
            sx={{ mb: 2 }}
          >
            <CardActionArea
              onClick={() =>
                this.props.onSelect(o)
              }
            >
              <CardContent>
                <Typography variant="h6">
                  {o.otc_title}
                </Typography>

                <Typography variant="subtitle1">
                  ₹ {o.otc_price}
                </Typography>

                <Typography variant="body2">
                  GST: {o.otc_tax || 0}%
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}

        {/* NO DATA */}
        {this.state.othercharges.length === 0 && (
          <Typography
            sx={{
              textAlign: "center",
              color: "#777",
              mt: 4,
            }}
          >
            No other charges found
          </Typography>
        )}

        {/* PAGINATION */}
        {this.state.totalItems > 0 && (
          <TablePagination
            component="div"
            count={this.state.totalItems}
            page={this.state.page}
            onPageChange={this.onPageChange}
            rowsPerPage={
              this.state.rowsPerPage
            }
            onRowsPerPageChange={
              this.onRowsPerPageChange
            }
            rowsPerPageOptions={[
              5,
              10,
              25,
              50,
            ]}
          />
        )}

        {/* ADD NEW OTHER CHARGE */}
        <Fab
          aria-label="add"
          onClick={this.props.onAddNew}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 1000,
            backgroundColor: "#11408f",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#0d3476",
            },
          }}
        >
          Add
        </Fab>
      </Box>
    );
  }
}

export default Invoiceothercharges;
